import script from "./AvaliateMaterialsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvaliateMaterialsButton.vue?vue&type=script&setup=true&lang=ts"

import "./AvaliateMaterialsButton.vue?vue&type=style&index=0&id=623c5f4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-623c5f4a"]])

export default __exports__